// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,
h2 {
  text-align: center;
}
a {
  text-decoration: none;
}
.logo {
  text-align: center;
}
.container {
  width: 100%;
  max-width: 2000px;
  margin: auto;
}
#a > li {
  list-style: none;
  padding-left: 20px;
  font-size: 30px;
  display: flex;
  align-items: center;
}

#a li a {
  color: #2ac37d;
}

.breadcrumb {
  width: 100%;
  height: 50px;
  background-color: #2ac37d;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-transform: uppercase;
}
.breadcrumb a {
  color: #ffffff;
  font-size: 8px
}
.item-link {
  display: block;
  width: 90%;
  max-width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background-color: black;
  color: #ffffff;
  padding: 10px 20px;
  margin: 30px auto;
}

.item-link:hover {
  opacity: 0.8;
}

.naviget {
  width: 100%;
  position: fixed;
  bottom: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
}
.naviget button {
  padding: 10px;
  width: 100px;
  font-weight: bold;
  background-color: #f1ab53;
  border-radius: 10px;
}
.products {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 20px;
  background-color: #e6e6e6;
  border-radius: 20px;
  margin-bottom: 100px;
  gap: 10px;
}

.product {
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  width: 250px;
}
.product .title {
  color: #2ac37d;
  font-weight: bold;
}
.product img {
  width: 250px;
  height: 220px;
}
.product a {
  padding: 5px;
  font-size: 16;
  font-weight: bold;
  text-align: center;
  background: #f1ab53;
  color: #fff;
  text-decoration: none;
  margin: 10px;
  display: block;
  border-radius: 5px;
  transition: all 0.2s ease;
}
.product a:hover {
  background-color: #e45636;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd;AACF;AACA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["body {\n  margin: 0 auto;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh1,\nh2 {\n  text-align: center;\n}\na {\n  text-decoration: none;\n}\n.logo {\n  text-align: center;\n}\n.container {\n  width: 100%;\n  max-width: 2000px;\n  margin: auto;\n}\n#a > li {\n  list-style: none;\n  padding-left: 20px;\n  font-size: 30px;\n  display: flex;\n  align-items: center;\n}\n\n#a li a {\n  color: #2ac37d;\n}\n\n.breadcrumb {\n  width: 100%;\n  height: 50px;\n  background-color: #2ac37d;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  text-transform: uppercase;\n}\n.breadcrumb a {\n  color: #ffffff;\n  font-size: 8px\n}\n.item-link {\n  display: block;\n  width: 90%;\n  max-width: 500px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  background-color: black;\n  color: #ffffff;\n  padding: 10px 20px;\n  margin: 30px auto;\n}\n\n.item-link:hover {\n  opacity: 0.8;\n}\n\n.naviget {\n  width: 100%;\n  position: fixed;\n  bottom: 1px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 50px;\n}\n.naviget button {\n  padding: 10px;\n  width: 100px;\n  font-weight: bold;\n  background-color: #f1ab53;\n  border-radius: 10px;\n}\n.products {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  padding: 20px;\n  background-color: #e6e6e6;\n  border-radius: 20px;\n  margin-bottom: 100px;\n  gap: 10px;\n}\n\n.product {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  border-radius: 10px;\n  background-color: #fff;\n  width: 250px;\n}\n.product .title {\n  color: #2ac37d;\n  font-weight: bold;\n}\n.product img {\n  width: 250px;\n  height: 220px;\n}\n.product a {\n  padding: 5px;\n  font-size: 16;\n  font-weight: bold;\n  text-align: center;\n  background: #f1ab53;\n  color: #fff;\n  text-decoration: none;\n  margin: 10px;\n  display: block;\n  border-radius: 5px;\n  transition: all 0.2s ease;\n}\n.product a:hover {\n  background-color: #e45636;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
